export default function MegaCard({children, ...props}) {
  return (
    <div className={'card ' + (props.otraClassname || '')} {...props}>
      {children}
    </div>
  )
}

function MegaCardHead({children, ...props}) {
  return (
    <div className={'p-6 border-b border-dark-h ' + (props.otraClassname || '')} {...props}>
      {children}
    </div>
  )
}

function MegaCardBody({children, ...props}) {
  return (
    <div className={'p-6 ' + (props.otraClassname || '')} {...props}>
      {children}
    </div>
  )
}

function MegaCardFooter({children, ...props}) {
  return (
    <div className={'p-6 border-t border-dark-h ' + (props.otraClassname || '')} {...props}>
      {children}
    </div>
  )
}

export{MegaCardHead, MegaCardBody, MegaCardFooter}